module.exports = __webpack_public_path__ + "static/media/logo-icon.1483b432.svg";